<template>
  <div>
    <div class="container-fluid title-page">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <h2>Meus Cursos</h2>
        </v-col>
      </v-row>
    </div>

    <div class="container-fluid">
      <v-row>

        <v-col cols="12" sm="12" md="12" class="mt-5">
          <v-btn class="tx-upper" color="success" dark :to="{name: 'course-create-step1'}">
            Cadastrar novo Curso
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="12" class="mb-5">
          <v-card class="list-app">
            <v-card-title>
              Listagem de Cursos
            </v-card-title>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :loading="loading"
              loading-text="Buscando cursos..."
              no-data-text="Nenhum curso encontrado"
              :items="courses"
              item-key="_id"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :options.sync="options"
              :page.sync="page"
              hide-default-footer
              :server-items-length="totalCourses"
              show-select
              class="elevation-3"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn
                  class="ma-1"
                  small
                  outlined
                  color="indigo accent-4"
                  v-if="item.manualCertificate && item.hasCertificate"
                  @click="openModalCertificate(item._id, item.title)"
                >
                  Liberar certificados
                </v-btn>
                <v-btn
                  class="ma-1"
                  small
                  outlined
                  :color="(item.active ? 'amber accent-4' : 'green accent-4')"
                  @click="activeCourse(item._id, !item.active)"
                >
                  {{ item.active ? 'Desativar' : 'Ativar' }}
                </v-btn>
                <v-btn
                  class="ma-1"
                  small
                  outlined
                  color="indigo"
                  :to="{name: 'course-create-step1', params: {courseId: item._id}}"
                >
                  Editar
                </v-btn>
                <v-btn
                  class="ma-1"
                  small
                  outlined
                  color="deep-orange accent-4"
                  @click="deleteItem(item)"
                >
                  Excluir
                </v-btn>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ item.createdAt | formatDate }}
              </template>
              <template v-slot:item.approve="{ item }">
                <v-tooltip bottom v-if="item.approve" open-delay="400">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      color="success"
                      small
                      outlined
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon left>check</v-icon>
                      Curso aprovado
                    </v-chip>
                  </template>
                  <span>Curso foi aprovado pelo administrador</span>
                </v-tooltip>
                <v-tooltip bottom v-else open-delay="400">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      color="orange darken-4"
                      small
                      outlined
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon left>warning</v-icon>
                      Pendente de aprovação
                    </v-chip>
                  </template>
                  <span>Curso está em análise pelo administrador</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <div class="text-center pt-5 pb-5">
              <v-pagination
                v-model="page"
                :length="pageCount"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-snackbar
        v-model="showAlert"
        :top="true"
        :color="colorAlert"
      >
        {{ textAlert }}
        <v-btn
          color="black"
          text
          @click="showAlert = false">
          Fechar
        </v-btn>
      </v-snackbar>
      <v-btn
        v-if="selected.length"
        color="red"
        dark
        bottom
        right
        fixed
        fab
        @click="removeSelected"
      >
        <v-icon>delete</v-icon>
      </v-btn>
    </div>

    <modal-certificate v-if="showModalCertificate" v-model="showModalCertificate" :course-id="courseId" :course-title="courseTitle"></modal-certificate>
  </div>
</template>

<script>
import { swalConfirm } from '@/helpers'
import ModalCertificate from './MyCourses/ModalCertificate'

export default {
  name: 'MyCourses',
  components: { ModalCertificate },
  data () {
    return {
      loading: true,
      showAlert: false,
      showModalCertificate: false,
      courseId: '',
      courseTitle: '',
      totalActive: 0,
      textAlert: '',
      colorAlert: 'info',
      search: '',
      selected: [],
      headers: [
        { text: 'Título', align: 'left', sortable: true, value: 'title', width: '40%' },
        { text: 'Data de criação', align: 'left', sortable: true, value: 'createdAt', width: '30%' },
        { text: 'Média', align: 'center', sortable: true, value: 'satisfaction', width: '10%' },
        { text: 'Aprovado', align: 'center', sortable: true, value: 'approve', width: '20%' },
        { text: '', align: 'right', sortable: false, value: 'actions', width: 420 }
      ],
      courses: [],
      totalCourses: 0,
      sortBy: 'createdAt',
      sortDesc: true,
      page: 1,
      pageCount: 0,
      options: {
        itemsPerPage: 10
      },
      pagination: {
        rowsPerPage: 10,
        sortBy: 'createdAt',
        descending: true
      }
    }
  },
  watch: {
    options: {
      handler () {
        this.getCourses()
      },
      deep: true,
    }
  },
  methods: {
    activeCourse (courseId, status) {
      this.axios.put('/user/course/active', { _id: courseId, status }).then(({ data }) => {
        if (data.success) {
          const course = this.courses.find(course => course._id === courseId)

          course.active = status
        } else {
          this.textAlert = data.message
          this.colorAlert = 'error'
          this.showAlert = true
        }
      }).catch(err => {
        console.error(err)

        this.textAlert = `Houve um erro ao ${(status) ? 'Ativar' : 'Desativar'}`
        this.colorAlert = 'error'
        this.showAlert = true
      })
    },
    getCourses () {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options,
        options = { sortBy: sortBy[0], sortDesc: sortDesc[0], page, itemsPerPage }

      this.axios.post('/user/course/my', { options }).then(({ data }) => {
        if (data.success) {
          this.totalCourses = data.totalCourses
          this.courses = data.courses.map(course => {
            return {
              _id: course._id,
              title: course.title,
              createdAt: course.createdAt,
              active: course.active,
              approve: course.approve,
              hasCertificate: course.hasCertificate,
              manualCertificate: course.manualCertificate,
              satisfaction: (course.avgSatisfaction ? parseFloat(course.avgSatisfaction).toFixed(2) : '')
            }
          })
        } else {
          this.textAlert = data.message
          this.colorAlert = 'error'
          this.showAlert = true
        }
      }).catch(err => {
        console.error(err)

        this.textAlert = 'Houve um erro ao listar os cursos'
        this.colorAlert = 'error'
        this.showAlert = true
      }).finally(() => {
        this.loading = false
      })
    },
    removeSelected () {
      const coursesId = this.selected.map(course => {
        return course._id
      })

      swalConfirm({
        title: `Confirma a exclusão de ${coursesId.length} cursos?`,
        text: 'Esse ação não poderá ser desfeita',
        type: 'warning',
      }).then(() => {
        this.axios.post('/user/course/delete/soft/multiple', { coursesId }).then(response => {
          if (response.data.success) {
            this.textAlert = 'Cursos excluídos com sucesso'
            this.colorAlert = 'success'

            this.selected = []

            this.getCourses()
          } else {
            this.textAlert = 'Houve um erro ao excluir os cursos'
            this.colorAlert = 'error'
          }
        }).catch(() => {
          this.textAlert = 'Houve um erro ao excluir os cursos'
          this.colorAlert = 'error'
        }).finally(() => {
          this.showAlert = true
        })
      })
    },
    deleteItem (item) {
      this.$swal({
        title: 'Confirma a exclusão do curso?',
        text: `O curso ${item.title} será excluído`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#B71C1C',
        cancelButtonColor: '#03A9F4',
        confirmButtonText: 'Excluir curso',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.axios.delete('/user/course/soft/' + item._id).then(response => {
            if (response.data.success) {
              this.textAlert = 'Curso excluído com sucesso'
              this.colorAlert = 'success'

              this.getCourses()
            } else {
              this.textAlert = 'Houve um erro ao excluir o curso'
              this.colorAlert = 'error'
            }
          }).catch(() => {
            this.textAlert = 'Houve um erro ao excluir o curso'
            this.colorAlert = 'error'
          }).finally(() => {
            this.showAlert = true
          })
        }
      })
    },
    openModalCertificate(courseId, courseTitle) {
      this.courseId = courseId
      this.courseTitle = courseTitle

      this.showModalCertificate = true
    }
  }
}
</script>
